import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

export interface CancelationInProgressDialogData {
  title: string;
  description: string;
  servicePhoneNumber: string;
}

@Component({
  template: `
    <pp-shell-dialog [title]="data.title | translate">
      <div mat-dialog-content>
        <p class="description">
          {{data.description | translate: ({servicePhoneNumber: data.servicePhoneNumber})}}
        </p>
      </div>
    </pp-shell-dialog>
  `,
  styleUrls: ['./cancellation-in-progress.dialog.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CancelationInProgressDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<CancelationInProgressDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CancelationInProgressDialogData
  ) {}
}
